module.exports = __webpack_public_path__ + "static/media/brief-voet.6692ce78.jpg";